<template lang="pug">
  .eui-partyFilters(:key="selection")
    h4.eui-partyFilters_title
      | Filter map
      transition(appear, name="fade")
        Button(v-if="selection", @handleClick='clearFilter', text="Close" dense)
          CloseIcon
    .eui-partyFilters_parties(v-if="partiesData")
      .eui-partyFilters_party(v-for="party in partiesData", :key="party.code", :class="{ selected: selection === party.code }")
        input( type="radio", name="filter_party", :id="party.inputId", :value="party.code", v-model="selection")
        label( :for="party.inputId" )
          PartyLabel(v-bind="party", layout="horizontal")
</template>

<script>
import shortid from 'shortid';

import PartyLabel from '../PartyLabel/PartyLabel.vue';
import Button from '../Button/Button.vue';
import CloseIcon from '../../assets/icon-cross.svg';


export default {
  name: 'partyFilters',
  props: {
    parties: {
      type: Array,
      default: () => ([])
    },
  },
  data() {
    return {
      selection: null,
      uid: shortid.generate()
    };
  },
  computed: {
    partiesData() {
      return this.parties.map( (party) => {
        const { color, code, displayCode, shortName } = party;
        return {
          inputId: `eui-partyFilters_party_${ code }_${ this.uid }`,
          name: (displayCode || shortName || code),
          code,
          color
        };
      } );
    }
  },
  methods: {
    clearFilter() {
      this.selection = null;
    }
  },
  watch: {
    selection(newValue) {
      this.$emit('filter:change', newValue);
    }
  },
  components: { PartyLabel, Button, CloseIcon }
};

</script>

<style lang="scss">
@import "src/core/scss/global-sass";

.eui-partyFilters {
	max-width: 100%;
	position: relative;
	text-align: left;
	z-index: 10;
  @include font-base-m;
  padding: var(--spacing-unit) 0;

	// h4.map-filters_title {
	// 	@include font-base-m;
	// 	@include thaustalianFonts();
	// }


  &_title {
    margin:0 0 var(--spacing-unit);
    position:relative;
    display: flex;
    text-transform: none;
    align-items: center;
  }

  &_parties {
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    align-items: flex-start;
    input { display: none;}
  }

  &_party {
    padding: 2px 0;
    line-height: 1.3em;
    width: auto;
		// width: 25%;

    &.selected {
      font-weight: bold;
    }

    .election-component[election-embed] & {
      width: 25%;
    }

    @include MQ_MobileOnly() {
      .election-component[election-embed] &,
      & {
        width: 33%;
      }
    }

    label {
      cursor: pointer;
      display: block;

      @include MQ_TabletAndUp() {
        span.fullname{ display: block; }
        span.code{ display: none; }
      }

      @include MQ_MobileOnly() {
        span.code{ display: block; }
        span.fullname{ display: none; }
      }
      .fullname {
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;
      }
    }
  }

  &_title {
    display: inline-block;
  }

  .eui-button {
    position: absolute;
    top: 50%;
    transform: translateY(-50%);
    left: 100%;
    margin-left: var(--spacing-unit);
  }
}
</style>
